import React, { memo } from 'react';

import './styles.scss';

const LightBoxCounter = ({ current, total }) => {
  return <div className="light-box-counter">{`${current} / ${total}`}</div>;
};

export default memo(LightBoxCounter);
